import { AxiosError, AxiosResponse } from "axios";
import psPlatformClient from "../../../../psPlatformClient";
import { QATConversationObjectType } from "../../../../ps-types/QATAIConversation";

interface QATAIConversationRequest {
  prompt: string;
  companyId: string;
  conversationObject: QATConversationObjectType;
  last3ResponsesFromAgent: string[];
}

const QATAIConversationResponseWrapper = async <Req, Res>(request: Promise<AxiosResponse<Res, Req>>): Promise<Res> => {
  try {
    const result = await request;
    return result.data;
  } catch (err) {
    if (err instanceof AxiosError && err.response && err.response.status >= 400) {
      if (err.response.data && typeof err.response.data === 'object') {
        const errResponseDescription = err.response.data?.description;
        if (errResponseDescription?.reason) {
          throw new Error(errResponseDescription?.reason);
        }
      }
    }
    throw err;
  }
};

export const converse = async (prompt: string, companyId: string, conversationObject: QATConversationObjectType, last3ResponsesFromAgent: string[]): Promise<QATConversationObjectType> => {
  return await QATAIConversationResponseWrapper<QATAIConversationRequest, QATConversationObjectType>(
    psPlatformClient<QATAIConversationRequest, QATConversationObjectType>({
      method: 'post',
      url: `/am/${companyId}/qat/converse`,
      data: {
        prompt,
        companyId,
        conversationObject,
        last3ResponsesFromAgent,
      }
    })
  );
};

export const QATAnalyzePropertyRisk = async (address: string, companyId: string): Promise<string> => {
  return await QATAIConversationResponseWrapper<{address: string}, string>(
    psPlatformClient<{address: string}, string>({
      method: 'post',
      url: `/am/${companyId}/qat/property-risk-screening`,
      data: {
        address,
      }
    })
  );
};

export const processDocument = async (
  companyId: string,
  inputs: QATConversationObjectType['inputs']['loi-generation']
): Promise<string> => {
  try {
    const response = await QATAIConversationResponseWrapper<{inputs: QATConversationObjectType['inputs']['loi-generation']}, string>(
      psPlatformClient<{inputs: QATConversationObjectType['inputs']['loi-generation']}, string>({
        method: 'post',
        url: `/am/${companyId}/qat/loi-generation`,
        data: { inputs }
      })
    );

    return response;
  } catch (error: any) {
    console.error('Document processing error:', error);
    throw error;
  }
};